module.exports = __webpack_public_path__ + "img/studyimg1.32e46f20.jpg";